<script setup>
import { useGlobals } from '@/composables/useGlobals'
import { defineAsyncComponent, onMounted } from 'vue'

const FooterBottom = defineAsyncComponent(
  () => import('@/components/basic/molecules/FooterBottom.vue')
)
const FooterGeneral = defineAsyncComponent(
  () => import('@/components/basic/molecules/FooterGeneral.vue')
)
const CmsBlock = defineAsyncComponent(
  () => import('@/components/basic/atoms/CmsBlock.vue')
)

defineProps({
  isReducedFooter: {
    type: Boolean,
    default: false
  }
})

const { hitLozad } = useGlobals()

onMounted(() => {
  hitLozad()
})
</script>

<template>
  <footer id="main-footer" class="mt-5">
    <div class="text-center mb-2">
      <span
        class="tax-info c-gray font-size-s"
        v-html="translate('fe_app_tax_info_footer')"
      >
      </span>
    </div>

    <FooterGeneral v-if="!isReducedFooter" id="footer-general" v-once />
    <!-- FooterLinks -->
    <CmsBlock
      v-if="!isReducedFooter"
      id="footer-links"
      class="bg-graphit mt-1 pt-3 c-white l-spacing-1 l-height-2 animate-link"
      identifier="footer_links_v2"
    />
    <FooterBottom id="footer-bottom" v-once />

    <div class="bg-graphit">
      <CmsBlock
        id="footer-copyright"
        class="c-ash-gray font-size-s"
        identifier="footer_bottom_copyright_v2"
      />
    </div>
  </footer>
</template>

<style scoped>
:deep(.footer-links-heading) {
  text-transform: uppercase;
}

#footer-links :deep(.app-icons) {
  height: 30px;
  padding-right: 10px;
}

.display-md-and-up #footer-links :deep(.app-icons) {
  height: 40px;
}

#footer-general {
  min-height: 800px;
}

.display-md-and-up #footer-general {
  min-height: 450px;
}

.display-lg-and-up #footer-general {
  min-height: 485px;
}

.bg-graphit,
.bg-chalkboard {
  :deep(a) {
    color: rgb(var(--v-theme-white));
  }
}

#main-footer :deep(ul) {
  padding-left: 0;
}

#footer-links :deep(ul li) {
  letter-spacing: 1.2px;
  font-family: var(--area-font-family);
  font-size: var(--m-font-size);
  line-height: 24.8px;
  padding: 10px 0;
}

.display-md-and-up #footer-links :deep(ul li) {
  padding: 0;
}

:deep(.animate-link a) {
  pointer-events: all;
  position: relative;
}

:deep(.animate-link a:not([class^='no-textdecoration'])::before) {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: -1px;
  left: 0;
  background-color: currentColor;
  visibility: hidden;
  transform: scaleX(0);
  transition: all var(--transition-duration-l) var(--transition-timing-ease) 0s;
}

:deep(.animate-link a:not([class^='no-textdecoration']):hover::before) {
  visibility: visible;
  transform: scaleX(1);
}

:deep(.animate-link a:hover) {
  text-decoration: inherit;
  color: inherit;
}
</style>
